/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  Badge,
  Button,
  Divider,
  Flex,
  Grid,
  Icon,
  ScrollView,
  SelectField,
  Text,
  TextField,
  useTheme,
} from "@aws-amplify/ui-react";
import { fetchByPath, getOverrideProps, validateField } from "./utils";
import { generateClient } from "aws-amplify/api";
import { createCampaign } from "../graphql/mutations";
const client = generateClient();
function ArrayField({
  items = [],
  onChange,
  label,
  inputFieldRef,
  children,
  hasError,
  setFieldValue,
  currentFieldValue,
  defaultFieldValue,
  lengthLimit,
  getBadgeText,
  runValidationTasks,
  errorMessage,
}) {
  const labelElement = <Text>{label}</Text>;
  const {
    tokens: {
      components: {
        fieldmessages: { error: errorStyles },
      },
    },
  } = useTheme();
  const [selectedBadgeIndex, setSelectedBadgeIndex] = React.useState();
  const [isEditing, setIsEditing] = React.useState();
  React.useEffect(() => {
    if (isEditing) {
      inputFieldRef?.current?.focus();
    }
  }, [isEditing]);
  const removeItem = async (removeIndex) => {
    const newItems = items.filter((value, index) => index !== removeIndex);
    await onChange(newItems);
    setSelectedBadgeIndex(undefined);
  };
  const addItem = async () => {
    const { hasError } = runValidationTasks();
    if (
      currentFieldValue !== undefined &&
      currentFieldValue !== null &&
      currentFieldValue !== "" &&
      !hasError
    ) {
      const newItems = [...items];
      if (selectedBadgeIndex !== undefined) {
        newItems[selectedBadgeIndex] = currentFieldValue;
        setSelectedBadgeIndex(undefined);
      } else {
        newItems.push(currentFieldValue);
      }
      await onChange(newItems);
      setIsEditing(false);
    }
  };
  const arraySection = (
    <React.Fragment>
      {!!items?.length && (
        <ScrollView height="inherit" width="inherit" maxHeight={"7rem"}>
          {items.map((value, index) => {
            return (
              <Badge
                key={index}
                style={{
                  cursor: "pointer",
                  alignItems: "center",
                  marginRight: 3,
                  marginTop: 3,
                  backgroundColor:
                    index === selectedBadgeIndex ? "#B8CEF9" : "",
                }}
                onClick={() => {
                  setSelectedBadgeIndex(index);
                  setFieldValue(items[index]);
                  setIsEditing(true);
                }}
              >
                {getBadgeText ? getBadgeText(value) : value.toString()}
                <Icon
                  style={{
                    cursor: "pointer",
                    paddingLeft: 3,
                    width: 20,
                    height: 20,
                  }}
                  viewBox={{ width: 20, height: 20 }}
                  paths={[
                    {
                      d: "M10 10l5.09-5.09L10 10l5.09 5.09L10 10zm0 0L4.91 4.91 10 10l-5.09 5.09L10 10z",
                      stroke: "black",
                    },
                  ]}
                  ariaLabel="button"
                  onClick={(event) => {
                    event.stopPropagation();
                    removeItem(index);
                  }}
                />
              </Badge>
            );
          })}
        </ScrollView>
      )}
      <Divider orientation="horizontal" marginTop={5} />
    </React.Fragment>
  );
  if (lengthLimit !== undefined && items.length >= lengthLimit && !isEditing) {
    return (
      <React.Fragment>
        {labelElement}
        {arraySection}
      </React.Fragment>
    );
  }
  return (
    <React.Fragment>
      {labelElement}
      {isEditing && children}
      {!isEditing ? (
        <>
          <Button
            onClick={() => {
              setIsEditing(true);
            }}
          >
            Add item
          </Button>
          {errorMessage && hasError && (
            <Text color={errorStyles.color} fontSize={errorStyles.fontSize}>
              {errorMessage}
            </Text>
          )}
        </>
      ) : (
        <Flex justifyContent="flex-end">
          {(currentFieldValue || isEditing) && (
            <Button
              children="Cancel"
              type="button"
              size="small"
              onClick={() => {
                setFieldValue(defaultFieldValue);
                setIsEditing(false);
                setSelectedBadgeIndex(undefined);
              }}
            ></Button>
          )}
          <Button size="small" variation="link" onClick={addItem}>
            {selectedBadgeIndex !== undefined ? "Save" : "Add"}
          </Button>
        </Flex>
      )}
      {arraySection}
    </React.Fragment>
  );
}
export default function CampaignCreateForm(props) {
  const {
    clearOnSuccess = true,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    ...rest
  } = props;
  const initialValues = {
    name: "",
    startDate: "",
    endDate: "",
    budget: "",
    totalDurationOfAds: "",
    estimatedCostOfCampaign: "",
    approvedCostOfCampaign: "",
    status: "",
    paid: "",
    keywords: [],
  };
  const [name, setName] = React.useState(initialValues.name);
  const [startDate, setStartDate] = React.useState(initialValues.startDate);
  const [endDate, setEndDate] = React.useState(initialValues.endDate);
  const [budget, setBudget] = React.useState(initialValues.budget);
  const [totalDurationOfAds, setTotalDurationOfAds] = React.useState(
    initialValues.totalDurationOfAds
  );
  const [estimatedCostOfCampaign, setEstimatedCostOfCampaign] = React.useState(
    initialValues.estimatedCostOfCampaign
  );
  const [approvedCostOfCampaign, setApprovedCostOfCampaign] = React.useState(
    initialValues.approvedCostOfCampaign
  );
  const [status, setStatus] = React.useState(initialValues.status);
  const [paid, setPaid] = React.useState(initialValues.paid);
  const [keywords, setKeywords] = React.useState(initialValues.keywords);
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    setName(initialValues.name);
    setStartDate(initialValues.startDate);
    setEndDate(initialValues.endDate);
    setBudget(initialValues.budget);
    setTotalDurationOfAds(initialValues.totalDurationOfAds);
    setEstimatedCostOfCampaign(initialValues.estimatedCostOfCampaign);
    setApprovedCostOfCampaign(initialValues.approvedCostOfCampaign);
    setStatus(initialValues.status);
    setPaid(initialValues.paid);
    setKeywords(initialValues.keywords);
    setCurrentKeywordsValue("");
    setErrors({});
  };
  const [currentKeywordsValue, setCurrentKeywordsValue] = React.useState("");
  const keywordsRef = React.createRef();
  const validations = {
    name: [{ type: "Required" }],
    startDate: [{ type: "Required" }],
    endDate: [{ type: "Required" }],
    budget: [],
    totalDurationOfAds: [],
    estimatedCostOfCampaign: [],
    approvedCostOfCampaign: [],
    status: [],
    paid: [],
    keywords: [],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          name,
          startDate,
          endDate,
          budget,
          totalDurationOfAds,
          estimatedCostOfCampaign,
          approvedCostOfCampaign,
          status,
          paid,
          keywords,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value === "") {
              modelFields[key] = null;
            }
          });
          await client.graphql({
            query: createCampaign.replaceAll("__typename", ""),
            variables: {
              input: {
                ...modelFields,
              },
            },
          });
          if (onSuccess) {
            onSuccess(modelFields);
          }
          if (clearOnSuccess) {
            resetStateValues();
          }
        } catch (err) {
          if (onError) {
            const messages = err.errors.map((e) => e.message).join("\n");
            onError(modelFields, messages);
          }
        }
      }}
      {...getOverrideProps(overrides, "CampaignCreateForm")}
      {...rest}
    >
      <TextField
        label="Name"
        isRequired={true}
        isReadOnly={false}
        value={name}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              name: value,
              startDate,
              endDate,
              budget,
              totalDurationOfAds,
              estimatedCostOfCampaign,
              approvedCostOfCampaign,
              status,
              paid,
              keywords,
            };
            const result = onChange(modelFields);
            value = result?.name ?? value;
          }
          if (errors.name?.hasError) {
            runValidationTasks("name", value);
          }
          setName(value);
        }}
        onBlur={() => runValidationTasks("name", name)}
        errorMessage={errors.name?.errorMessage}
        hasError={errors.name?.hasError}
        {...getOverrideProps(overrides, "name")}
      ></TextField>
      <TextField
        label="Start date"
        isRequired={true}
        isReadOnly={false}
        value={startDate}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              name,
              startDate: value,
              endDate,
              budget,
              totalDurationOfAds,
              estimatedCostOfCampaign,
              approvedCostOfCampaign,
              status,
              paid,
              keywords,
            };
            const result = onChange(modelFields);
            value = result?.startDate ?? value;
          }
          if (errors.startDate?.hasError) {
            runValidationTasks("startDate", value);
          }
          setStartDate(value);
        }}
        onBlur={() => runValidationTasks("startDate", startDate)}
        errorMessage={errors.startDate?.errorMessage}
        hasError={errors.startDate?.hasError}
        {...getOverrideProps(overrides, "startDate")}
      ></TextField>
      <TextField
        label="End date"
        isRequired={true}
        isReadOnly={false}
        value={endDate}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              name,
              startDate,
              endDate: value,
              budget,
              totalDurationOfAds,
              estimatedCostOfCampaign,
              approvedCostOfCampaign,
              status,
              paid,
              keywords,
            };
            const result = onChange(modelFields);
            value = result?.endDate ?? value;
          }
          if (errors.endDate?.hasError) {
            runValidationTasks("endDate", value);
          }
          setEndDate(value);
        }}
        onBlur={() => runValidationTasks("endDate", endDate)}
        errorMessage={errors.endDate?.errorMessage}
        hasError={errors.endDate?.hasError}
        {...getOverrideProps(overrides, "endDate")}
      ></TextField>
      <TextField
        label="Budget"
        isRequired={false}
        isReadOnly={false}
        type="number"
        step="any"
        value={budget}
        onChange={(e) => {
          let value = isNaN(parseFloat(e.target.value))
            ? e.target.value
            : parseFloat(e.target.value);
          if (onChange) {
            const modelFields = {
              name,
              startDate,
              endDate,
              budget: value,
              totalDurationOfAds,
              estimatedCostOfCampaign,
              approvedCostOfCampaign,
              status,
              paid,
              keywords,
            };
            const result = onChange(modelFields);
            value = result?.budget ?? value;
          }
          if (errors.budget?.hasError) {
            runValidationTasks("budget", value);
          }
          setBudget(value);
        }}
        onBlur={() => runValidationTasks("budget", budget)}
        errorMessage={errors.budget?.errorMessage}
        hasError={errors.budget?.hasError}
        {...getOverrideProps(overrides, "budget")}
      ></TextField>
      <TextField
        label="Total duration of ads"
        isRequired={false}
        isReadOnly={false}
        type="number"
        step="any"
        value={totalDurationOfAds}
        onChange={(e) => {
          let value = isNaN(parseFloat(e.target.value))
            ? e.target.value
            : parseFloat(e.target.value);
          if (onChange) {
            const modelFields = {
              name,
              startDate,
              endDate,
              budget,
              totalDurationOfAds: value,
              estimatedCostOfCampaign,
              approvedCostOfCampaign,
              status,
              paid,
              keywords,
            };
            const result = onChange(modelFields);
            value = result?.totalDurationOfAds ?? value;
          }
          if (errors.totalDurationOfAds?.hasError) {
            runValidationTasks("totalDurationOfAds", value);
          }
          setTotalDurationOfAds(value);
        }}
        onBlur={() =>
          runValidationTasks("totalDurationOfAds", totalDurationOfAds)
        }
        errorMessage={errors.totalDurationOfAds?.errorMessage}
        hasError={errors.totalDurationOfAds?.hasError}
        {...getOverrideProps(overrides, "totalDurationOfAds")}
      ></TextField>
      <TextField
        label="Estimated cost of campaign"
        isRequired={false}
        isReadOnly={false}
        type="number"
        step="any"
        value={estimatedCostOfCampaign}
        onChange={(e) => {
          let value = isNaN(parseFloat(e.target.value))
            ? e.target.value
            : parseFloat(e.target.value);
          if (onChange) {
            const modelFields = {
              name,
              startDate,
              endDate,
              budget,
              totalDurationOfAds,
              estimatedCostOfCampaign: value,
              approvedCostOfCampaign,
              status,
              paid,
              keywords,
            };
            const result = onChange(modelFields);
            value = result?.estimatedCostOfCampaign ?? value;
          }
          if (errors.estimatedCostOfCampaign?.hasError) {
            runValidationTasks("estimatedCostOfCampaign", value);
          }
          setEstimatedCostOfCampaign(value);
        }}
        onBlur={() =>
          runValidationTasks("estimatedCostOfCampaign", estimatedCostOfCampaign)
        }
        errorMessage={errors.estimatedCostOfCampaign?.errorMessage}
        hasError={errors.estimatedCostOfCampaign?.hasError}
        {...getOverrideProps(overrides, "estimatedCostOfCampaign")}
      ></TextField>
      <TextField
        label="Approved cost of campaign"
        isRequired={false}
        isReadOnly={false}
        type="number"
        step="any"
        value={approvedCostOfCampaign}
        onChange={(e) => {
          let value = isNaN(parseFloat(e.target.value))
            ? e.target.value
            : parseFloat(e.target.value);
          if (onChange) {
            const modelFields = {
              name,
              startDate,
              endDate,
              budget,
              totalDurationOfAds,
              estimatedCostOfCampaign,
              approvedCostOfCampaign: value,
              status,
              paid,
              keywords,
            };
            const result = onChange(modelFields);
            value = result?.approvedCostOfCampaign ?? value;
          }
          if (errors.approvedCostOfCampaign?.hasError) {
            runValidationTasks("approvedCostOfCampaign", value);
          }
          setApprovedCostOfCampaign(value);
        }}
        onBlur={() =>
          runValidationTasks("approvedCostOfCampaign", approvedCostOfCampaign)
        }
        errorMessage={errors.approvedCostOfCampaign?.errorMessage}
        hasError={errors.approvedCostOfCampaign?.hasError}
        {...getOverrideProps(overrides, "approvedCostOfCampaign")}
      ></TextField>
      <SelectField
        label="Status"
        placeholder="Please select an option"
        isDisabled={false}
        value={status}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              name,
              startDate,
              endDate,
              budget,
              totalDurationOfAds,
              estimatedCostOfCampaign,
              approvedCostOfCampaign,
              status: value,
              paid,
              keywords,
            };
            const result = onChange(modelFields);
            value = result?.status ?? value;
          }
          if (errors.status?.hasError) {
            runValidationTasks("status", value);
          }
          setStatus(value);
        }}
        onBlur={() => runValidationTasks("status", status)}
        errorMessage={errors.status?.errorMessage}
        hasError={errors.status?.hasError}
        {...getOverrideProps(overrides, "status")}
      >
        <option
          children="Approved"
          value="Approved"
          {...getOverrideProps(overrides, "statusoption0")}
        ></option>
        <option
          children="Declined"
          value="Declined"
          {...getOverrideProps(overrides, "statusoption1")}
        ></option>
        <option
          children="Pending"
          value="Pending"
          {...getOverrideProps(overrides, "statusoption2")}
        ></option>
        <option
          children="Partially approved"
          value="PartiallyApproved"
          {...getOverrideProps(overrides, "statusoption3")}
        ></option>
      </SelectField>
      <SelectField
        label="Paid"
        placeholder="Please select an option"
        isDisabled={false}
        value={paid}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              name,
              startDate,
              endDate,
              budget,
              totalDurationOfAds,
              estimatedCostOfCampaign,
              approvedCostOfCampaign,
              status,
              paid: value,
              keywords,
            };
            const result = onChange(modelFields);
            value = result?.paid ?? value;
          }
          if (errors.paid?.hasError) {
            runValidationTasks("paid", value);
          }
          setPaid(value);
        }}
        onBlur={() => runValidationTasks("paid", paid)}
        errorMessage={errors.paid?.errorMessage}
        hasError={errors.paid?.hasError}
        {...getOverrideProps(overrides, "paid")}
      >
        <option
          children="Paid"
          value="Paid"
          {...getOverrideProps(overrides, "paidoption0")}
        ></option>
        <option
          children="Un paid"
          value="UnPaid"
          {...getOverrideProps(overrides, "paidoption1")}
        ></option>
        <option
          children="Partially paid"
          value="PartiallyPaid"
          {...getOverrideProps(overrides, "paidoption2")}
        ></option>
        <option
          children="In process"
          value="InProcess"
          {...getOverrideProps(overrides, "paidoption3")}
        ></option>
      </SelectField>
      <ArrayField
        onChange={async (items) => {
          let values = items;
          if (onChange) {
            const modelFields = {
              name,
              startDate,
              endDate,
              budget,
              totalDurationOfAds,
              estimatedCostOfCampaign,
              approvedCostOfCampaign,
              status,
              paid,
              keywords: values,
            };
            const result = onChange(modelFields);
            values = result?.keywords ?? values;
          }
          setKeywords(values);
          setCurrentKeywordsValue("");
        }}
        currentFieldValue={currentKeywordsValue}
        label={"Keywords"}
        items={keywords}
        hasError={errors?.keywords?.hasError}
        runValidationTasks={async () =>
          await runValidationTasks("keywords", currentKeywordsValue)
        }
        errorMessage={errors?.keywords?.errorMessage}
        setFieldValue={setCurrentKeywordsValue}
        inputFieldRef={keywordsRef}
        defaultFieldValue={""}
      >
        <TextField
          label="Keywords"
          isRequired={false}
          isReadOnly={false}
          value={currentKeywordsValue}
          onChange={(e) => {
            let { value } = e.target;
            if (errors.keywords?.hasError) {
              runValidationTasks("keywords", value);
            }
            setCurrentKeywordsValue(value);
          }}
          onBlur={() => runValidationTasks("keywords", currentKeywordsValue)}
          errorMessage={errors.keywords?.errorMessage}
          hasError={errors.keywords?.hasError}
          ref={keywordsRef}
          labelHidden={true}
          {...getOverrideProps(overrides, "keywords")}
        ></TextField>
      </ArrayField>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Clear"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          {...getOverrideProps(overrides, "ClearButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Submit"
            type="submit"
            variation="primary"
            isDisabled={Object.values(errors).some((e) => e?.hasError)}
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
